// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".align-table[data-v-492eeec8] td,.align-table[data-v-492eeec8] th{text-align:left}", ""]);
// Exports
module.exports = exports;
